import init from "./downloadFile";
import scroll from "./scroll";
scroll();
init();